// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* This file is DEPRECATED
   We are moving to the Octopus Design System
   https://www.octopus.design
  
   When changing component styles:
   1. Do not use variables from this file
   2. Aim to use Emotion \`css\` + themeTokens.colors
       - see Dashboard.tsx for example
   3. If you need to use Less, reference CSS variables
       - see index.ejs for example
       - for full list see https://github.com/OctopusDeploy/OctopusDeploy/blob/main/frontend/packages/design-system-tokens/src/generated/themeTokens.ts
   4. Remove variables from this file when they are no longer used
 */
@media (max-width: 37.4rem) {
  .style_hide-sm__dsBvW {
    display: none !important;
  }
}
@media (min-width: 37.4rem) {
  .style_visible-sm__IxCIK {
    display: none !important;
  }
}
@media (max-width: 79.9rem) {
  .style_hide-md__Ps5LU {
    display: none !important;
  }
}
@media (min-width: 79.9rem) {
  .style_visible-md__ZJHYy {
    display: none !important;
  }
}
.style_sideMenu__LUaIP {
  padding: 0 1rem;
  width: 16.6rem;
  flex: 0 0 auto;
}
.style_breakword___Qd8s {
  word-wrap: break-word;
  word-break: break-word;
}
.style_name__rGDOv {
  word-wrap: break-word;
  word-break: break-word;
  font-size: 1.625rem;
  line-height: 1.5rem;
  min-width: 50%;
  padding-top: 1.5rem;
  line-height: 1.75rem;
}
.style_nameHorizontal__k_dMq {
  word-wrap: break-word;
  word-break: break-word;
  font-size: 1.625rem;
  line-height: 1.5rem;
  min-width: 50%;
}
.style_resourceType__t44ud {
  text-transform: uppercase;
  color: var(--colorTextTertiary);
  font-size: 0.75rem;
}
.style_description__bPrcY {
  word-wrap: break-word;
  word-break: break-word;
  padding-top: 1.5rem;
}
.style_preNav__xHtcR {
  padding: 0.875rem 0;
}
.style_links__aWI7S {
  padding-top: 0.875rem;
}
.style_link__sXKpi {
  display: block;
  font-size: 1rem;
  line-height: 2.5rem;
  text-align: left;
  color: var(--colorTextPrimary);
  text-decoration: none;
  padding-left: 1rem;
}
.style_link__sXKpi > :active,
.style_link__sXKpi > :visited {
  color: var(--colorTextPrimary);
}
a.style_link__sXKpi:hover {
  color: var(--colorTextLinkPressed);
  background: var(--colorBackgroundTertiary);
}
.style_selected__pM8h0 {
  color: var(--colorTextLinkDefault) !important;
  font-weight: 500;
}
.style_stackedLayout__fuG9f {
  display: flex;
  flex-direction: column;
}
.style_title__swDrw {
  display: flex;
  flex-direction: row;
  margin: 0.5rem;
  align-items: center;
}
.style_logo__xgLlc {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.style_horizontalLinks__AFYPP {
  height: 2.5rem;
  margin: 0;
  padding-bottom: 1rem;
}
.style_horizontalLinks__AFYPP ul {
  margin: 0;
}
.style_horizontalLinks__AFYPP ul li {
  display: inline-block;
}
.style_horizontalLinks__AFYPP ul li a {
  display: block;
  font-size: 1rem;
  line-height: 2.5rem;
  text-align: left;
  color: var(--colorTextPrimary);
  text-decoration: none;
  padding-left: 1rem;
  padding-right: 1rem;
}
.style_horizontalLinks__AFYPP ul li a > :active,
.style_horizontalLinks__AFYPP ul li a > :visited {
  color: var(--colorTextPrimary);
}
.style_horizontalLinks__AFYPP ul li a:hover {
  color: var(--colorTextLinkPressed);
  background: var(--colorBackgroundPrimaryHover);
}
.style_horizontalLinks__AFYPP ul li a em {
  font-size: 1.0625rem;
  padding: 0 0.5rem;
}
.style_sidebarLayout__qOd0z {
  display: flex;
  margin-top: 0.875rem;
  margin-right: 1rem;
}
.style_sidebarLayoutContent__B97zl {
  flex: 1 1 auto;
  display: flex;
  justify-content: space-around;
  padding: 0.125rem;
  min-width: 0;
}
.style_nestedNavLinks__F9Cgf {
  margin-left: 1rem;
}
.style_nestedNavLinks__F9Cgf .style_link__sXKpi {
  line-height: 2.25rem;
}
`, "",{"version":3,"sources":["webpack://./app/components/NavigationSidebarLayout/style.less","webpack://./app/resources/styles/media.less"],"names":[],"mappings":"AAAA;;;;;;;;;;;;EAYE;ACNF;EACE;IACE,wBAAA;EDQF;AACF;ACLA;EACE;IACE,wBAAA;EDOF;AACF;ACJA;EACE;IACE,wBAAA;EDMF;AACF;ACJA;EACE;IACE,wBAAA;EDMF;AACF;AA7BA;EACI,eAAA;EACA,cAAA;EACA,cAAA;AA+BJ;AA7BA;EACI,qBAAA;EACA,sBAAA;AA+BJ;AA5BA;EAJI,qBAAA;EACA,sBAAA;EAWA,mBAAA;EACA,mBAAA;EACA,cAAA;EARA,mBAAA;EACA,oBAAA;AAkCJ;AA/BA;EAVI,qBAAA;EACA,sBAAA;EAWA,mBAAA;EACA,mBAAA;EACA,cAAA;AAkCJ;AA/BA;EACI,yBAAA;EACA,+BAAA;EACA,kBAAA;AAiCJ;AA9BA;EAvBI,qBAAA;EACA,sBAAA;EAwBA,mBAAA;AAiCJ;AA9BA;EACI,mBAAA;AAgCJ;AA7BA;EACI,qBAAA;AA+BJ;AA5BA;EACI,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;EACA,qBAAA;EACA,kBAAA;AA8BJ;AA7BI;;EAEI,8BAAA;AA+BR;AA5BA;EACI,kCAAA;EACA,0CAAA;AA8BJ;AA5BA;EACI,6CAAA;EACA,gBAAA;AA8BJ;AA3BA;EACI,aAAA;EACA,sBAAA;AA6BJ;AA1BA;EACI,aAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AA4BJ;AAzBA;EACI,mBAAA;EACA,oBAAA;AA2BJ;AAxBA;EACI,cAAA;EACA,SAAA;EACA,oBAAA;AA0BJ;AA7BA;EAKQ,SAAA;AA2BR;AAhCA;EAOY,qBAAA;AA4BZ;AAnCA;EAtCI,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;EACA,qBAAA;EACA,kBAAA;EA0CY,mBAAA;AAmChB;AA5EI;;EAEI,8BAAA;AA8ER;AAtCgB;EACI,kCAAA;EACA,8CAAA;AAwCpB;AArDA;EAgBoB,oBAAA;EACA,iBAAA;AAwCpB;AAjCA;EACI,aAAA;EACA,oBAAA;EACA,kBAAA;AAmCJ;AAhCA;EACI,cAAA;EACA,aAAA;EACA,6BAAA;EACA,iBAAA;EAGA,YAAA;AAgCJ;AA7BA;EACI,iBAAA;AA+BJ;AAhCA;EAGQ,oBAAA;AAgCR","sourcesContent":["@import \"../../resources/styles/variables\";\n@import \"../../resources/styles/colors\";\n@import \"../../resources/styles/media\";\n.sideMenu {\n    padding: 0 1rem;\n    width: 16.6rem;\n    flex: 0 0 auto;\n}\n.breakword{\n    word-wrap: break-word;\n    word-break: break-word;\n}\n\n.name {\n    .nameHorizontal;\n    padding-top: 1.5rem;\n    line-height: 1.75rem;\n}\n\n.nameHorizontal {\n    .breakword;\n    font-size: 1.625rem;\n    line-height: 1.5rem;\n    min-width: 50%; //required for ie and ff to word-wrap properly\n}\n\n.resourceType {\n    text-transform: uppercase;\n    color: @secondaryText;\n    font-size: 0.75rem;\n}\n\n.description {\n    .breakword;\n    padding-top: 1.5rem;\n}\n\n.preNav {\n    padding: 0.875rem 0;\n}\n\n.links {\n    padding-top: 0.875rem;\n}\n\n.link {\n    display: block;\n    font-size: 1rem;\n    line-height: 2.5rem;\n    text-align: left;\n    color: @primaryText;\n    text-decoration: none;\n    padding-left: 1rem;\n    &>:active,\n    &>:visited {\n        color: @primaryText;\n    }\n}\na.link:hover{\n    color: @primaryDark;\n    background: @secondaryBackground;\n}\n.selected {\n    color: @primary !important;\n    font-weight: @semibold;\n}\n\n.stackedLayout {\n    display: flex;\n    flex-direction: column;\n}\n\n.title {\n    display: flex;\n    flex-direction: row;\n    margin: 0.5rem;\n    align-items: center;\n}\n\n.logo {\n    margin-left: 0.5rem;\n    margin-right: 0.5rem;\n}\n\n.horizontalLinks {\n    height: 2.5rem;\n    margin: 0;\n    padding-bottom: 1rem;\n    ul {\n        margin: 0;\n        li {\n            display: inline-block;\n            a {\n                .link;\n                padding-right: 1rem;\n                &:hover {\n                    color: @primaryDark;\n                    background: @hover;\n                }\n                em {\n                    font-size: 1.0625rem;\n                    padding: 0 0.5rem;\n                }\n            }\n        }\n    }\n}\n\n.sidebarLayout {\n    display: flex;\n    margin-top: 0.875rem;\n    margin-right: 1rem;\n}\n\n.sidebarLayoutContent {\n    flex: 1 1 auto;\n    display: flex;\n    justify-content: space-around;\n    padding: 0.125rem;\n    // https://www.w3.org/TR/css-flexbox-1/#min-size-auto\n    // This prevents the child from growing larger than the parent flexbox container if the childs content is large\n    min-width: 0;\n}\n\n.nestedNavLinks {\n    margin-left: 1rem;\n    .link {\n        line-height: 2.25rem;\n    }\n}\n","//@screen-xs: 480px;\n@screen-sm: 37.4rem; //600px\n@screen-md: 79.9rem; //1279px\n//@screen-lg-min: 1280px;\n//@scree-xl-min: 1920px;\n\n@media (max-width: @screen-sm) {\n  .hide-sm {\n    display: none !important;\n  }\n}\n\n@media (min-width: @screen-sm) {\n  .visible-sm {\n    display: none !important;\n  }\n}\n\n@media (max-width: @screen-md) {\n  .hide-md {\n    display: none !important;\n  }\n}\n@media (min-width: @screen-md) {\n  .visible-md {\n    display: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hide-sm": `style_hide-sm__dsBvW`,
	"hideSm": `style_hide-sm__dsBvW`,
	"visible-sm": `style_visible-sm__IxCIK`,
	"visibleSm": `style_visible-sm__IxCIK`,
	"hide-md": `style_hide-md__Ps5LU`,
	"hideMd": `style_hide-md__Ps5LU`,
	"visible-md": `style_visible-md__ZJHYy`,
	"visibleMd": `style_visible-md__ZJHYy`,
	"sideMenu": `style_sideMenu__LUaIP`,
	"breakword": `style_breakword___Qd8s`,
	"name": `style_name__rGDOv`,
	"nameHorizontal": `style_nameHorizontal__k_dMq`,
	"resourceType": `style_resourceType__t44ud`,
	"description": `style_description__bPrcY`,
	"preNav": `style_preNav__xHtcR`,
	"links": `style_links__aWI7S`,
	"link": `style_link__sXKpi`,
	"selected": `style_selected__pM8h0`,
	"stackedLayout": `style_stackedLayout__fuG9f`,
	"title": `style_title__swDrw`,
	"logo": `style_logo__xgLlc`,
	"horizontalLinks": `style_horizontalLinks__AFYPP`,
	"sidebarLayout": `style_sidebarLayout__qOd0z`,
	"sidebarLayoutContent": `style_sidebarLayoutContent__B97zl`,
	"nestedNavLinks": `style_nestedNavLinks__F9Cgf`
};
module.exports = ___CSS_LOADER_EXPORT___;
